// Mobile polyfills for better compatibility

// Notification API polyfill
if (typeof window !== 'undefined' && typeof window.Notification === 'undefined') {
  window.Notification = function(title, options) {
    console.log('Notification (polyfill):', title, options);
    return {
      close: function() {
        console.log('Notification closed');
      }
    };
  };
  
  window.Notification.requestPermission = function() {
    return Promise.resolve('denied');
  };
  
  window.Notification.permission = 'denied';
}

// ResizeObserver polyfill
if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
  window.ResizeObserver = function(callback) {
    return {
      observe: function() {},
      unobserve: function() {},
      disconnect: function() {}
    };
  };
}

// requestAnimationFrame polyfill for older browsers
if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'undefined') {
  window.requestAnimationFrame = function(callback) {
    return setTimeout(callback, 16);
  };
}

// matchMedia polyfill
if (typeof window !== 'undefined' && typeof window.matchMedia === 'undefined') {
  window.matchMedia = function(query) {
    return {
      matches: false,
      media: query,
      onchange: null,
      addListener: function() {},
      removeListener: function() {},
      addEventListener: function() {},
      removeEventListener: function() {},
      dispatchEvent: function() { return false; }
    };
  };
}

console.log('Mobile polyfills loaded');
